import LanguagesList from "./LanguagesList";
import MenuComponent from "./MenuComponent";


type StateProps = {
  langSelected: string;
  setLangSelected: any;
}

const Languages:React.FC<StateProps> = (props) => {
  const {langSelected, setLangSelected} = props;
    return (
      <MenuComponent
        menuTitle={langSelected ? langSelected : sessionStorage.getItem("lang")?sessionStorage.getItem("lang"):"en"}
        menuList={<LanguagesList langSelected={langSelected} setLangSelected={setLangSelected} />}
        isToggleMenuManually={false}
      />
    );
  };
  export default Languages